module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/2@2x_5f55265aba21ca5d16f21237dcbf739b.png";